import { MenuItem, ListItemIcon, Menu, useTheme, useMediaQuery, } from "@mui/material";
import React from "react";
import { More } from "iconsax-react";
import { Icon } from "@iconify/react";
import { SIconButton } from "../buttons";
export const SMenuTrigger = ({ size = "small", color = "default", onClick, disabled = false }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
    return (React.createElement(SIconButton, { size: size, onClick: onClick, disabled: disabled, colorVariant: isSmallScreen ? "inherit" : "primary", showBackground: isSmallScreen ? false : true, title: "More options" }, isSmallScreen ? (React.createElement(Icon, { icon: "nrk:more", width: "24", height: "24" })) : (React.createElement(Icon, { icon: "lsicon:more-filled", width: 20 }))));
};
export const SMenu = ({ anchorEl, open, handleClose, menuItems, right = "50%", showTriggerButton = false, triggerButtonSize = "small", triggerButtonColor = "default", onTriggerClick, closeOnClick = true, }) => {
    return (React.createElement(React.Fragment, null,
        showTriggerButton && (React.createElement(SIconButton, { size: triggerButtonSize, onClick: onTriggerClick, colorVariant: "primary", showBackground: true, title: "Menu options" },
            React.createElement(More, { size: triggerButtonSize === "small"
                    ? 16
                    : triggerButtonSize === "medium"
                        ? 20
                        : 24 }))),
        React.createElement(Menu, { anchorEl: anchorEl, id: "account-menu", open: open, onClose: handleClose, slotProps: {
                paper: {
                    elevation: 0,
                    sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.15))",
                        mt: 1.5,
                        "&::before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                        },
                    },
                },
            }, transformOrigin: { horizontal: "right", vertical: "top" }, anchorOrigin: { horizontal: "right", vertical: "bottom" }, 
            // The menu is portalled in the DOM but stays a child of its trigger in the
            // React tree, so clicks would otherwise bubble into a clickable container
            // such as a card or grid row and trigger its onClick as well.
            onClick: (e) => e.stopPropagation() }, menuItems.map((item, index) => (React.createElement(MenuItem, { key: index, className: item.color === "error" ? "error-item" : "", onClick: (e) => {
                e.stopPropagation();
                if (item.onClick) {
                    item.onClick();
                }
                if (closeOnClick) {
                    handleClose();
                }
            }, disabled: item.disabled, selected: item.selected },
            item.icon && React.createElement(ListItemIcon, null, item.icon),
            item.label))))));
};
